'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../aviary-core/dist/cjs/index.cjs');

/**
 * SVG Illustration of search
 */ const Search = ({ assetColor = index.ASSET_COLORS.grey, size = index.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M61.1679 36.1112V31.3456H62.6463C63.7247 31.3456 64.599 30.4713 64.599 29.3929V24.2769C64.599 23.1985 63.7247 22.3242 62.6463 22.3242H35.1081C34.0297 22.3242 33.1554 23.1985 33.1554 24.2769V29.3929C33.1554 30.4713 34.0297 31.3456 35.1081 31.3456H36.5865V36.1816C34.7038 36.8692 33.0802 38.1061 31.9336 39.7262C30.787 41.3463 30.1723 43.2722 30.1719 45.2454V77.6679C30.1719 78.7463 31.0461 79.6206 32.1246 79.6206H65.8372C66.9156 79.6206 67.7899 78.7463 67.7899 77.6679V45.2498C67.7898 43.2394 67.152 41.279 65.9652 39.6411C64.7784 38.0033 63.1016 36.7695 61.1679 36.1112Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "32.918",
                y: "22.3145",
                width: "31.605",
                height: "9.03001",
                rx: "1.34453",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M67.8465 65.0585C66.7537 65.6234 65.5976 66.0489 64.3901 66.3297C62.5068 66.7675 60.5796 66.8357 58.6619 66.5323C56.7441 66.2289 54.9319 65.5693 53.2756 64.5718C51.5601 63.5385 50.0888 62.1869 48.9023 60.5547C47.7156 58.9222 46.8841 57.1056 46.4307 55.1549C45.9929 53.2717 45.9247 51.3444 46.2281 49.4267C46.5316 47.5089 47.1912 45.6967 48.1887 44.0405C49.222 42.325 50.5735 40.8536 52.2057 39.6671C53.8382 38.4804 55.6548 37.6489 57.6055 37.1956C59.4888 36.7578 61.416 36.6895 63.3337 36.993C65.2515 37.2964 67.0637 37.956 68.72 38.9535C70.4355 39.9868 71.9068 41.3384 73.0933 42.9705C74.28 44.603 75.1115 46.4196 75.5649 48.3703C76.0027 50.2536 76.0709 52.1808 75.7675 54.0986C75.464 56.0163 74.8044 57.8285 73.8069 59.4848C72.7736 61.2003 71.422 62.6716 69.7896 63.858C69.1677 64.3102 68.519 64.7106 67.8465 65.0585ZM55.2911 40.6666C54.7287 40.9573 54.1845 41.2927 53.6627 41.6719C50.9673 43.6311 49.1961 46.5228 48.6756 49.8141C48.1551 53.1053 48.9473 56.4022 50.9067 59.098C52.8659 61.7933 55.7576 63.5646 59.0489 64.0851C61.7029 64.5046 64.3613 64.0708 66.7042 62.8596C67.2669 62.5689 67.8108 62.2335 68.3327 61.8542C71.028 59.895 72.7993 57.0033 73.3198 53.7121C73.8403 50.4208 73.048 47.1239 71.0886 44.4282C69.1295 41.7328 66.2377 39.9616 62.9465 39.4411C60.2925 39.0215 57.634 39.4553 55.2911 40.6666Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M70.9969 71.1156C70.2152 71.5198 69.2541 71.2137 68.85 70.432L66.0726 65.0594C65.6685 64.2777 65.9745 63.3166 66.7562 62.9125C67.538 62.5083 68.499 62.8144 68.9031 63.5961L71.6806 68.9687C72.0847 69.7504 71.7787 70.7115 70.9969 71.1156Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M78.8529 86.3029C77.2899 87.1109 75.3675 86.4988 74.5594 84.9357L67.9303 72.1124C67.1222 70.5493 67.7344 68.6269 69.2974 67.8188C70.8605 67.0107 72.7829 67.6229 73.591 69.186L80.2201 82.0093C81.0282 83.5724 80.416 85.4948 78.8529 86.3029Z",
                fill: theme.ds5.asset[assetColor]["500"]
            })
        ]
    });
};

exports.Search = Search;
//# sourceMappingURL=Search.cjs.map
